import {
  urlRegisterPlayerLastName,
  urlRegisterPlayerPhone,
} from "../../../urls";
import { Keyboard } from "../../../components/keyboard";
import { Button } from "@repo/ui/components/button";
import { useLocation } from "react-router";
import { useCurrentPos } from "../../../hooks/use-current-pos";
import { countries } from "@repo/ui/lib/countries";
import { Container } from "../../../components/container";
import { Title } from "../../../components/title";
import { useState } from "react";
import { InputText } from "../../../components/input-text";

function Phone() {
  const { club } = useCurrentPos();
  const { state } = useLocation();

  const [country, setCountry] = useState(state.country || club.country);
  const [phone, setPhone] = useState(state.phone || "");

  return (
    <Container>
      <Title className="text-2xl!">¿Cuál es tu teléfono?</Title>
      <div className="flex items-center justify-center gap-2">
        {countries.map((ctry) => (
          <Button
            key={ctry.value}
            type="button"
            variant={ctry.value === country ? "pos" : "pos-outline"}
            onClick={() => setCountry(ctry.value)}
          >
            {ctry.flag} {ctry.label}
          </Button>
        ))}
      </div>
      <InputText value={phone} placeholder="Escribe tu teléfono..." />
      <Keyboard
        type="numbers"
        onChange={setPhone}
        value={phone}
        mode="capitalize"
      />
      <Button
        className="w-full"
        variant="pos"
        size="4xl"
        disabled={phone.length < 9}
      >
        Continuar
      </Button>
    </Container>
  );
}

export const route = {
  path: urlRegisterPlayerPhone(),
  element: <Phone />,
  handle: {
    backLink: urlRegisterPlayerLastName(),
  },
};
